import * as d3 from "d3";
import Spinner from 'spin.js';
const MyWorker = require("worker!./worker.js");

const myWorker = new MyWorker();
const spinner = new Spinner().spin();
myWorker.addEventListener('message', function(e) {

}, false);
myWorker.onmessage = function (e) {
  document.getElementById('message').textContent = "";
  renderData(e.data);
  spinner.stop();
  myWorker.terminate();
};

document.addEventListener('DOMContentLoaded', ()=> {
  d3.select("#myForm")
    .on('submit',(e) => {
      d3.event.preventDefault();
      let choice = d3.event.target.firstElementChild.value;
      beginSimulation(choice);
    });
});

function beginSimulation(duration) {
  d3.select("#myForm")
    .remove();
  d3.select("#message")
    .append("h1")
    .style("text-align", "center")
    .style("font-size", "10vmax")
    .style("margin-top", "10vmin")
    .style("cursor","wait")
    .text("Simulating World!");
  document.getElementById('content').appendChild(spinner.el);
  myWorker.postMessage(duration);
}

function renderData(data) {
  let countries = data;
  window.diseaseRate = [
    ...data.map(country => country.land.diseaseRate)
  ].reduce((sum, el) => sum + el);
  let list = d3.select("#content")
    .append("ul")
    .style("position", "absolute")
    .style("flex-flow","row wrap")
    .style("display", "flex")
    .style("justify-content", "center")
    .style("color", "black")
    .style("width", "100vmax")
    .style("margin-top", "2vmin")
    .style("font-family", "sans-serif")
    .style("font-size", "2vmax")
    .selectAll("p")
    .data(countries);

  list.enter().append("li")
    .style("list-style","none")
    .style("float", "left")
    .style("margin-left", "5vmax")
    .style("margin-right", "5vmax")
    .style("cursor", "pointer")
    .attr("id", (d) => d.name)
    .text((d) => d.name)
    .on('click', (d) => expandCountry(d));

  list.exit().remove();
}

function expandCountry(country) {
  let categories = ["History", "Evolutionary details", "Land"];
  reset();
  let selected = d3.select(`#${country.name}`)
    .transition()
    .duration(750)
    .style("color", "blue")
    .style("font-weight", "bold");

  let category = d3.select("#info")
    .style("position", "absolute")
    .style("flex-flow","row wrap")
    .style("display", "flex")
    .style("justify-content", "center")
    .style("width","100vmax")
    .style("box-sizing","content-box")
    .style("margin-top", "12vmin")
    .style("font-family", "sans-serif")
    .style("font-size", "1.5vmax")
    .selectAll("p")
    .data(categories);

  category.enter().append("li")
    .style("list-style","none")
    .style("float", "left")
    .style("margin-right", "3vmax")
    .attr("id",(d) => d.split(' ')[0])
    .style("cursor", "pointer")
    .text((d) => d)
    .on('click', (d) => revealData(d,country));

  category.exit().remove();
}

function revealData(category, country) {
  resetCategories();
  let selected = d3.select(`#${category.split(' ')[0]}`)
    .transition()
    .duration(750)
    .style("color", "blue")
    .style("font-weight", "bold");

  switch (category) {
    case "History":
      showHistory(country);
      break;
    case "Evolutionary details":
      showDetails(country);
      break;
    case "Land":
      showLand(country);
      break;
    case "Trace lineage":
      showLineage(country);
      break;
    default:

  }
}

function showHistory(country) {
  d3.select("#presentation")
    .selectAll("*").remove();

  let data = country.history.populationTimeline;

  let h = window.innerHeight * 0.7,
    w = window.innerWidth * 0.8,
    padding = 1;

  let svg = d3.select("#presentation")
              .append("svg")
              .style("position","absolute")
              .style("margin-top","15vmin")
              .style("left","50%")
              .style("transform","translateX(-50%)")
              .style("width",w)
              .style("height",h);

  d3.select("svg")
    .append("text")
    .style("text-align", "center")
    .style("font-size", "1vmax")
    .style("font-weight", "bold")
    .attr("x", w / 2.5)
    .attr("y", 25)
    .text("Population (mouseover bar for events)");

  let heightScale = d3.scaleLinear()
    .domain([0,d3.max(data)])
    .range([0,h - 50]);

  svg.selectAll("rect")
     .data(data)
     .enter()
     .append("rect")
     .on("mouseover", (d,i) => displayEvent(country.history.events[i]))
  	 .on("mouseout", (d,i) => hideEvent())
     .attr("x",(d,i) => i * (w / data.length))
     .attr("y",(d) => h)
     .transition()
     .delay((d,i) => 50 * i)
     .attr("y",(d) => h - heightScale(d))
     .attr("width",w / data.length - padding)
     .attr("height",(d) => heightScale(d))
     .attr("fill", (d) =>`rgb(0,0,${10*d})`);

  svg.selectAll("text")
     .data(data)
     .enter()
     .append("text")
     .text((d) => d)
     .attr("x",(d,i) => i * (w / data.length) + (w / data.length - padding) / 2)
     .attr("y",(d) => h - heightScale(d) - 14)
     .attr("font-family", "sans-serif")
     .attr("fill", "black")
     .attr("font-size", "11px")
     .attr("text-anchor", "middle");
}

function displayEvent(event) {
  let h = window.innerHeight * 0.7;
  let w = window.innerWidth * 0.8;
  let textEvent = d3.select("svg")
    .append("text")
    .style("font-size", "1vmax")
    .attr("class","event")
    .style("text-align", "center")
    .attr("x", 0)
    .attr("y", 50)
    .text(event);
}

function hideEvent() {
  d3.select(".event")
    .remove();
}

function showDetails(country) {
  d3.select("#presentation")
    .selectAll("*").remove();

  let strTimeline = country.stats.timeline.map(el => el.str);
  let intTimeline = country.stats.timeline.map(el => el.int);
  let healthTimeline = country.stats.timeline.map(el => el.health);


  let h = window.innerHeight * 0.7,
    w = window.innerWidth * 0.8,
    padding = 50;

  let xScale = d3.scaleLinear()
    .domain([0,strTimeline.length])
    .range([padding,w - padding * 2]);

  let yScale = d3.scaleLinear()
    .domain([0,d3.max(strTimeline.concat(intTimeline,healthTimeline))])
    .range([h - padding, padding]);

  let rScale = d3.scaleLinear()
    .domain([0,d3.max(strTimeline.concat(intTimeline,healthTimeline))])
    .range([2,5]);

  let svg = d3.select("#presentation")
    .append("svg")
    .style("position","absolute")
    .style("margin-top","15vmin")
    .style("left","50%")
    .style("transform","translateX(-50%)")
    .style("width",w)
    .style("height",h);

  d3.select("svg")
    .append("text")
    .style("text-align", "center")
    .style("font-size", "1vmax")
    .style("font-weight", "bold")
    .attr("x", w / 2.5)
    .attr("y", 25)
    .style("transform","translateX(-50%)")
    .text("Attributes over time");

  let data = strTimeline.concat(intTimeline,healthTimeline);

  svg.selectAll("circle")
     .data(data)
     .enter()
     .append("circle")
     .on("mouseover", (d,i) => {
       let text;
       if (i < data.length / 3) {
         text = `Strength: ${Math.round(d,2)}`;
       } else if (i < data.length * (2/3)) {
         text = `Intelligence: ${Math.round(d,2)}`;
       } else {
         text = `Health: ${Math.round(d,2)}`;
       }
       d3.select("svg")
         .append("text")
         .style("font-size", "1vmax")
         .attr("class","event")
         .style("text-align", "center")
         .attr("x", xScale(i % (data.length / 3)) + padding)
         .attr("y", yScale(d))
         .text(text);
     })
     .on("mouseout", () => hideEvent())
     .style("fill",(d, i) => {
       if (i < data.length / 3) {
         return "red";
       } else if (i < data.length * (2/3)) {
         return "blue";
       } else {
         return "green";
       }
     })
     .attr("cx",(d, i)=> 0 )
     .attr("cy",(d)=>h)
     .transition()
     .duration(500)
     .delay((d,i) => i * 40)
     .attr("cx",(d, i)=>xScale(i % (data.length / 3)) + padding)
     .attr("cy",(d)=>yScale(d))
     .attr("r", (d)=> rScale(d));

  let xAxis = d3.axisBottom()
     .scale(xScale);

  let yAxis = d3.axisLeft()
     .scale(yScale)
     .ticks(5);

  svg.append("g")
     .attr("class","axis")
     .attr("transform", `translate(0,${h - padding})`)
     .call(xAxis);

  svg.append("g")
     .attr("class", "axis")
     .attr("transform", `translate(${padding},0)`)
     .call(yAxis);

   d3.select("#presentation")
     .append("text")
     .style("position", "absolute")
     .style("left", "50%")
     .style("bottom", "5vmin")
     .style("transform","translateX(-50%)")
     .style("font-size", "1vmax")
     .style("color", "red")
     .attr("x", 250)
     .attr("y", 25)
     .text("| strength |")
        .append("text")
        .style("color","blue")
        .text("| intelligence |")
          .append("text")
          .style("color","green")
          .text("| health |");
}

function showLand(country) {
  d3.select("#presentation")
    .selectAll("*").remove();

  let h = window.innerHeight * 0.7,
    w = window.innerWidth * 0.8,
    padding = 50;

  let climate = country.land.climate,
    diseaseRate = country.land.diseaseRate,
    totalLand = country.land.totalLand,
    useableLand = country.land.useableLand;

  let xScale = d3.scaleLinear()
    .domain([0,totalLand])
    .range([padding,(w - padding) / 6]);

  let yScale = d3.scaleLinear()
    .domain([0,100])
    .range([h - padding, padding]);

  let svg = d3.select("#presentation")
    .append("svg")
    .style("position","absolute")
    .style("margin-top","15vmin")
    .style("left","50%")
    .style("transform","translateX(-50%)")
    .style("width",w)
    .style("height",h);

  d3.select("svg")
    .append("text")
    .style("text-align", "center")
    .style("font-size", "1vmax")
    .style("font-weight", "bold")
    .attr("x", w / 2.5)
    .attr("y", 25)
    .style("transform","translateX(-50%)")
    .text("Generated land (hover over for information)");

  let relativeDiseaseRate = diseaseRate / window.diseaseRate;
  d3.select("svg")
    .append("circle")
    .on("mouseover", (d,i) => showDiseaseRate(relativeDiseaseRate))
    .on("mouseout", (d,i) => hideEvent())
    .style("fill", () => {
      if (relativeDiseaseRate < 0.25) {
        return "lightgrey";
      } else if (relativeDiseaseRate < 0.35) {
        return "darkgrey";
      } else {
        return "black";
      }
    })
    .attr("cx",() => w / 2 )
    .attr("cy",() => h / 2 )
    .attr("r", ()=> xScale(0))
    .transition()
    .duration(750)
    .attr("r", (d)=> xScale(totalLand));

    let freeLand = (useableLand / totalLand) * (360);
    d3.select("svg")
      .append("path")
      .on("mouseover", (d,i) => showUseableLand(climate,totalLand, useableLand))
   	  .on("mouseout", (d,i) => hideEvent())
      .attr("d",describeArc(w / 2, h / 2, xScale(0), 0 , freeLand))
      .attr("fill","black")
      .transition()
      .duration(750)
      .attr("d",describeArc(w / 2, h / 2, xScale(totalLand), 0 , freeLand))
      .attr("fill",() => {
        if (climate < 70) {
          return "blue";
        } else if (climate < 80) {
          return "yellow";
        } else if (climate < 90) {
          return "orange";
        } else {
          return "red";
        }
      });
}

function showUseableLand(climate,total, free) {
  let h = window.innerHeight * 0.7;
  let w = window.innerWidth * 0.8;
  let [clim, tot, use] = [climate, total, free].map( el => Math.round( el, 2));
  let event = `Climate: ${clim}&#8457; | Total Land: ${tot} acres | Farmable Land: ${use} acres`;
  let textEvent = d3.select("svg")
    .append("text")
    .style("font-size", "2vmax")
    .attr("class","event")
    .style("text-align", "center")
    .attr("x", w / 4)
    .attr("y", h - 25)
    .html(event);
}

function showDiseaseRate(disease) {
  let h = window.innerHeight * 0.7;
  let w = window.innerWidth * 0.8;
  let event = "Relative disease rate to other countries: " + Math.round(disease * 100) + "%";
  let textEvent = d3.select("svg")
    .append("text")
    .style("font-size", "2vmax")
    .attr("class","event")
    .style("text-align", "center")
    .attr("x", w / 4)
    .attr("y", h - 25)
    .text(event);
}

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  let angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;

  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  };
}

function describeArc(x, y, radius, startAngle, endAngle){

    let start = polarToCartesian(x, y, radius, endAngle);
    let end = polarToCartesian(x, y, radius, startAngle);

    let largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    let d = [
        "M", start.x, start.y,
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
    ].join(" ");

    return d;
}

function showLineage(country) {

}

function resetCategories() {
  d3.selectAll("#info>li")
    .transition()
    .duration(750)
    .style("color", "black")
    .style("font-weight", "normal");
}

function reset() {
  d3.selectAll("#content>ul>li")
    .transition()
    .duration(750)
    .style("color", "black")
    .style("font-weight", "normal");

  d3.select("#info")
    .selectAll("*").remove();

  d3.select("#presentation")
    .selectAll("*").remove();
}

// function extractPopulation(country) {
//   return {
//     name: country.name,
//     population: country.population,
//     stats: {
//       health: country.avgHealth,
//       intelligence: country.avgInt,
//       strength: country.avgStr,
//       timeline: country.attributeTimeline
//     },
//     land: {
//       climate: country.climate,
//       diseaseRate: country.diseaseRate,
//       useableLand: country.farmableLand,
//       totalLand: country.size
//     },
//     people: {
//       males: country.males,
//       females: country.females
//     },
//     history: {
//       events: country.history,
//       populationTimeline: country.populationTimeline
//     }
//   };
// }



/** WEBPACK FOOTER **
 ** ./evolution.js
 **/